<script lang="ts">
import { AppLanguageSwitcherComponent } from "./app-language-switcher.ts";
export default AppLanguageSwitcherComponent;
</script>

<template>
    <div
        class="header__lang lang-switcher"
        :style="{ cursor: 'pointer' }"
        v-click-outside="() => model.toggleSwitcher(false)"
        ref="switcher"
        :class="{ 'is-active': this.model.active }"
    >
        <div
            class="lang-switcher__item lang-switcher__item_empty"
            @click="() => model.toggleSwitcher()"
        >
            <svg class="sprite-icon lang-switcher__icon">
                <use xlink:href="/img/sprite.svg#languages"></use>
            </svg>
            <span class="lang-switcher__label">
                <i18n-t keypath="common.languages" />
            </span>
        </div>
        <ul class="lang-switcher__dropdown" ref="innerSwitcher">
            <li
                class="lang-switcher__item lang-switcher__item_nl"
                :class="[`lang-switcher__item_${lang}`]"
                :key="lang"
                v-for="lang in AppLanguageCode"
            >
                <a
                    @click.stop.prevent="model.switchLang(lang)"
                    :class="{ 'is-active': lang === model.lang }"
                >
                    <img
                        class="lang-switcher__icon"
                        :src="`/img/languages/${lang}.svg`"
                        alt=""
                    />
                    <span class="lang-switcher__label">
                        <i18n-t :keypath="`lang.${lang}`" />
                    </span>
                </a>
            </li>
        </ul>
    </div>
</template>
